import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <div className="admin-container">

      <Sidebar role={user.role} />

      <div className="admin-main">

        <Navbar />

        <div className="admin-content">

          <div className="welcome-card">
            <h2>Admin Dashboard</h2>
            <p>Welcome, <b>{user.name}</b></p>
          </div>

          <div className="stats-grid">

            <div
              className="card blue"
              onClick={() => navigate("/admin/staff")}
            >
              <h3>Staff</h3>
              <p>Create & manage staff users</p>
            </div>

            <div
              className="card purple"
              onClick={() => navigate("/admin/staff-password")}
            >
              <h3>Staff Password</h3>
              <p>Update staff passwords</p>
            </div>

            <div
              className="card green"
              onClick={() => navigate("/admin/reports")}
            >
              <h3>Reports</h3>
              <p>Sales, orders, profit & analytics</p>
            </div>

            <div
              className="card orange"
              onClick={() => navigate("/admin/leads")}
            >
              <h3>Leads</h3>
              <p>Manage leads & status tracking</p>
            </div>

            <div
              className="card red"
              onClick={() => navigate("/admin/leads/assign")}
            >
              <h3>Assign Leads</h3>
              <p>Bulk assign leads to staff</p>
            </div>

            {/* ===============================
                🔥 ADMIN ACTIVITY (USER ACTIONS)
            =============================== */}
            <div
              className="card dark"
              onClick={() => navigate("/admin/activities")}
            >
              <h3>Admin Activity</h3>
              <p>User actions, visits & lead activity</p>
            </div>

            {/* ===============================
                🔥 SYSTEM ACTIVITY LOGS (AUDIT)
            =============================== */}
            <div
              className="card black"
              onClick={() => navigate("/admin/activity-logs")}
            >
              <h3>System Activity Logs</h3>
              <p>Full audit logs & system tracking</p>
            </div>

            {/* 📸 VISIT PROOFS */}
            <div
              className="card teal"
              onClick={() => navigate("/admin/visit-proofs")}
            >
              <h3>Visit Proofs</h3>
              <p>View uploaded visit images</p>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;